module.exports = "https://static.wagwalking.com/_next/static/images/review1-3358857f21123a89057db74b56bdead8.webp";